import * as yup from 'yup';

const summaryFormSchema = yup
.object()
  .shape({
    start_date: yup.date().typeError('Required').required("Required")
    .test("past_date", "Must not be past date", (startDate) => {
        const now = new Date();
        const nowDate = new Date(now.setHours(0,0,0,0));
        return startDate >= nowDate;
    })
})
.required();

export default summaryFormSchema;